<template>
  <LdapItemTable
    ref="itemTable"
    :asidePanelCanceledEventName="legacyAsidePanelCanceledEventName"
    :inDetailsAsidePanel="false"
    :isAsideOpen="isAsideOpen"
    :panelType="mainPanel"
    :selectedModelId="selectedModelId"
    :setGettingStartedTooltipVisibility="showTooltip"
    :setSelectedModelId="setSelectedModelId"
    :viewport="viewport"
  />
</template>
<script>
import { ItemTableConsts } from 'client/util/Constants';
import LdapItemTable from 'client/ldap/components/LdapItemTable.vue';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import OptimizelyHelper from 'client/GrowthEngineering/OptimizelyHelper';

export default {
  name: 'LdapMainPanel',

  components: {
    LdapItemTable,
  },

  mixins: [MainPanelMixin],

  data() {
    return {
      mainPanel: ItemTableConsts.panelType.mainPanel,
    };
  },

  created() {
    OptimizelyHelper.trackLdapPageView();

    // TODO: Rather than importing these legacy event names from Backbone
    // components they should be moved to client/util/Constants.js!
    this.legacyAsidePanelCanceledEventName = 'directory-details:canceled';
    this.legacyAsidePanelSavedEventName = 'directory-details:saved';
  },
};
</script>
